import React from 'react';
import logo from '../logo.svg';
import '../App.css';
import {FilmStrip} from "./style/StyledDiv";
import {Main} from "./Main";

function App() {
    return (
        <>
            <link rel="stylesheet"
                  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>

            <div>

                    <Main></Main>


            </div>
        </>
    );
}

export default App;
